import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
	outlinedButton: {
		borderColor: "#7F51FF",
		borderRadius: 4,
		borderWidth: "1px",
		textTransform: "capitalize !important",
		fontWeight: "bold",
	},
}));
